var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0001C32 24.8366 24.8366 32.0001 16 32.0001C7.16344 32.0001 0 24.8366 0 16.0001C0 7.16351 7.16344 6.10352e-05 16 6.10352e-05C24.8366 6.10352e-05 32 7.16351 32 16.0001ZM1.98701 16.0001C1.98701 23.7392 8.26084 30.0131 16 30.0131C23.7392 30.0131 30.013 23.7392 30.013 16.0001C30.013 8.2609 23.7392 1.98707 16 1.98707C8.26084 1.98707 1.98701 8.2609 1.98701 16.0001Z",
    fill: "#EFEFEF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8.00006,
    width: 2,
    height: 16,
    rx: 1,
    fill: "#8E59FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17.0001,
    width: 2,
    height: 16,
    rx: 1,
    transform: "rotate(-90 8 17.0001)",
    fill: "#8E59FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAdd);
export default __webpack_public_path__ + "static/media/SidebarAdd.abfb636cb65b8f1e882e310633d733f9.svg";
export { ForwardRef as ReactComponent };